import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/api/axios';

export const getAuditCasePermissions = async (auditCaseUuid: string) => {
  const { data } = await api.get<{ actions: string[] }>(`/audit-cases/${auditCaseUuid}/actions`);

  return data;
};

export const useGetAuditCasePermissions = (
  auditCaseId: string,
): UseQueryResult<{ actions: string[] }, Error> => {
  return useQuery({
    queryKey: [auditCaseId, 'permissions'],
    queryFn: () => getAuditCasePermissions(auditCaseId),
  });
};
